import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class NavBarItem extends PureComponent {
  render() {
    const { className, children, active, ...others } = this.props;
    const cls = classNames({
      "weui-navbar__item": true,
      "weui-bar__item_on": active
    }, className);
    return (
      <div className={ cls } { ...others }>
        { children }
      </div>
    );
  }
}
